import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    GET_USER_REQUEST,
    GET_USER_FAIL,
    GET_USER_SUCCESS,
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAIL,
    PASSWORD_CHANGE_REQUEST,
    PASSWORD_CHANGE_SUCCESS,
    PASSWORD_CHANGE_FAIL,
    CHANGE_LOCALE
} from '../constants/Users';

const initialState = {
    login: '',
    password: '',
    companyId: '',
    isAdmin: false
};

export default function user(state = initialState, action) {
    switch (action.type) {
        case LOGIN_REQUEST:
        case LOGOUT_REQUEST:
        case LOGIN_FAIL:
        case GET_USER_REQUEST:
        case GET_USER_FAIL:
        case PASSWORD_RESET_REQUEST:
        case PASSWORD_RESET_SUCCESS:
        case PASSWORD_RESET_FAIL:
        case PASSWORD_CHANGE_REQUEST:
        case PASSWORD_CHANGE_SUCCESS:
        case PASSWORD_CHANGE_FAIL:
            return state;
        case LOGIN_SUCCESS:
        case GET_USER_SUCCESS: {
            const user = action.payload;
            return {
                ...state, login: user.login, password: user.password,
                companyId: user.companyId, isAdmin: user.isAdmin
            };
        }
        case LOGOUT_SUCCESS:
            return {...state, login: '', password: '', companyId: '', isAdmin: false};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js